import apolloClient from "../apolloClient";
import { CREATE_CUSTOMER } from "./graphql";

class CustomerService {
	async create(model) {
		const { data } = await apolloClient.mutate({
			mutation: CREATE_CUSTOMER,
			variables: {
				customer: mapToCreate(model),
			},
		});
		return data.createCustomer.customer.id;
	}
}

export default new CustomerService();

const mapToCreate = (model) => {
	const {
		customer: { email, address },
	} = model;

	return {
		email: email,
		firstName: address.firstName,
		lastName: address.lastName,
		phone: address.phone,
	};
};
